/**
 * ItemCategoryService
 * Service for ItemCategory entity operations
 * Route: api/itemcategory
 * Controller: ItemCategoryController.cs
 */
import { CrudService } from '../base/CrudService';
/**
 * ItemCategoryService
 * Handles item category CRUD operations
 * Maps to /api/itemcategory endpoint
 */
export class ItemCategoryService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? ItemCategoryService.DEFAULT_SERVICE_PATH,
            basePath: ItemCategoryService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
ItemCategoryService.DEFAULT_SERVICE_PATH = 'procurements';
ItemCategoryService.BASE_PATH = 'api/itemcategory';
//# sourceMappingURL=ItemCategoryService.js.map